module.exports = __webpack_public_path__ + "static/media/ic-menu.7848d4ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-menu.svg
// module id = 641
// module chunks = 14